"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./Slider'));

//# sourceMappingURL=index.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./components/Slider/index.js
 ** module id = 244
 ** module chunks = 0
 **/